import React from 'react';
import { MapColors } from 'const';

import { useKineticMapLiveProjection } from '../MapContext';
import DragHandler from './DragHandler/DragHandler';
import { DragElementProps } from './types';
import useDragStyles from './styles';

/** This component crashes if `centerLatLng` is not `[Lng, Lat]`?
 *
 * HOWEVER: `setCenterLatLng` returns a `[Lat, Lng]` ???
 *
 * You have been warned
 *
 * TODO: Fix this.
 */
const DragElement: React.FunctionComponent<DragElementProps> = ({
  centerLatLng,
  setCenterLatLng,
  altSVG,
  deleteable,
  disabled = false,
  fill = 'none',
  stroke = 'red',
  showMoveCursor = false,
}) => {
  const classes = useDragStyles();

  const point = useKineticMapLiveProjection(centerLatLng);
  if (!point) {
    return null;
  }

  const cursorClass = !disabled && showMoveCursor ? classes.draggable : '';
  return (
    <DragHandler
      onDrag={setCenterLatLng}
      onDragStart={(latLng) => {
        setCenterLatLng(latLng);
      }}
      onDragEnd={(_latLng, event) => {
        event.preventDefault();
        if (event.button === 2) {
          // The user most likely clicked the right mouse button.
          setCenterLatLng(null);
        }
      }}
    >
      {({ onMouseDown, onContextMenu }) => {
        return altSVG ? (
          React.cloneElement(altSVG, {
            onMouseDown: !disabled ? onMouseDown : () => null,
            onContextMenu: deleteable && !disabled ? onContextMenu : () => null,
            className: cursorClass,
          })
        ) : (
          <circle
            className={cursorClass}
            fill={disabled ? MapColors.BLUE : fill}
            stroke={disabled ? MapColors.BLUE : stroke}
            strokeWidth='3px'
            cx={point.x}
            cy={point.y}
            r={5}
            onMouseDown={!disabled ? onMouseDown : () => null}
            onContextMenu={deleteable && !disabled ? onContextMenu : () => null}
          />
        );
      }}
    </DragHandler>
  );
};

export default DragElement;
